import GraficoLucro from "../../components/charts/GraficoLucro";
export default function GraficoTab({
  chartData,
  showWithoutSat,
  setShowWithoutSat,
  theme,
  displayCurrency,
}) {
  return (
    <div>
      <GraficoLucro
        chartData={chartData}
        showWithoutSat={showWithoutSat}
        onToggleSat={setShowWithoutSat}
        theme={theme}
        displayCurrency={displayCurrency}
      />
    </div>
  );
}
